import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = ["canvas", "input"]
  static values = { emptyMessage: String }

  connect() {
    this.pad = new SignaturePad(this.canvasTarget)
    this.resize()
    this.resizeHandler = () => this.resize()
    window.addEventListener("resize", this.resizeHandler)
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeHandler)
    this.pad.off()
  }

  resize() {
    const data = this.pad.toData()
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    const canvas = this.canvasTarget

    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext("2d").scale(ratio, ratio)

    this.pad.clear()
    this.pad.fromData(data)
  }

  clear() {
    this.pad.clear()
  }

  save(event) {
    if (this.pad.isEmpty()) {
      event.preventDefault()
      window.alert(this.emptyMessageValue)
      return
    }

    this.inputTarget.value = this.pad.toDataURL("image/png")
  }
}
